import { render, staticRenderFns } from "./CampIntro.vue?vue&type=template&id=5e24f1eb&scoped=true&lang=pug"
import script from "./CampIntro.vue?vue&type=script&lang=js"
export * from "./CampIntro.vue?vue&type=script&lang=js"
import style0 from "./CampIntro.vue?vue&type=style&index=0&id=5e24f1eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e24f1eb",
  null
  
)

export default component.exports